export default "__VITE_ASSET__DaqDMBnk__"